import { queryOptions } from "@tanstack/react-query";

import { ApiClient } from "~/api/api-client";

import type { TrackingPublicConfig } from "./tracker";

/**
 * Ids públicos de medición (`GET /api/tracking/public-config`). Se cargan desde /admin/tracking y
 * se guardan cifrados en `secrets`: cambiar un id no requiere rebuild. Si la API falla, `null` =
 * todo apagado, nunca un error en pantalla.
 */
export const trackingPublicConfigQueryOptions = queryOptions({
  queryKey: ["tracking-public-config"],
  queryFn: async (): Promise<TrackingPublicConfig | null> => {
    try {
      const response = await ApiClient.api.trackingControllerGetTrackingPublicConfig();
      return response.data.data;
    } catch {
      return null;
    }
  },
  staleTime: 1000 * 60 * 5,
  retry: false,
});

export type SiteVerification = TrackingPublicConfig["verification"];

/** Solo tokens con pinta de token: el valor termina en un atributo del `<head>`. */
const TOKEN_RE = /^[A-Za-z0-9_\-.=]{4,200}$/;

export function sanitizeVerification(
  verification: Partial<SiteVerification> | null | undefined,
): SiteVerification {
  const clean = (value: string | null | undefined) =>
    value && TOKEN_RE.test(value.trim()) ? value.trim() : null;
  return {
    google: clean(verification?.google),
    meta: clean(verification?.meta),
    bing: clean(verification?.bing),
  };
}
